import Vue from 'vue'
import App from './app.vue'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import axios from 'axios'

import Toasted from 'vue-toasted'

import { Timeline } from 'vue-visjs'

import VueTimers from 'vue-timers'

import Default from './router/layouts/main.vue'
import Auth from './router/layouts/auth.vue'

import vSelect from 'vue-select'

import ECharts from 'vue-echarts' // refers to components/ECharts.vue in webpack
import VueSimpleAlert from 'vue-simple-alert'
import UUID from 'vue-uuid'
import { MediaQueries } from 'vue-media-queries'

import moment from 'moment'
import en from 'moment/src/locale/en-gb'
// import de from 'moment/src/locale/de'

// import ECharts modules manually to reduce bundle size
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/map'
import 'echarts/lib/chart/heatmap'
import 'echarts/lib/chart/radar'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/chart/effectScatter'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/polar'
import 'echarts/lib/component/geo'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/visualMap'
import 'echarts/lib/component/dataset'

import config from './editorConfig.js'
import makeCrudModule from './state/crud'
import makeCrudRoutes from './router/crud'
import makeService from './services/api'

import EditContainer from './components/EditContainer.vue'
import GridContainer from './components/GridContainer.vue'

import KiosksEditor from './components/crud/editors/Kiosks.vue'
import AirlinesEditor from './components/crud/editors/Airlines.vue'
import AirlineGroupEditor from './components/crud/editors/AirlineGroup.vue'
import MenuAirlines from './components/crud/editors/MenuAirlines.vue'
import OperationalHours from './components/crud/editors/OperationalHours.vue'
import ApisRoutes from './components/crud/editors/ApisRoutes.vue'
Vue.component('editor-kiosks', KiosksEditor)
Vue.component('editor-airlines', AirlinesEditor)
Vue.component('editor-airlinegroup', AirlineGroupEditor)
Vue.component('editor-menuairlines', MenuAirlines)
Vue.component('editor-operatinghours', OperationalHours)
Vue.component('editor-apisroutes', ApisRoutes)



Vue.use(VueSimpleAlert, { title: 'Vue Simple Alert', width: '420px' })

// If you want to use ECharts extensions, just import the extension package and it will work
// Taking ECharts-GL as an example:
// You only need to install the package with `npm install --save echarts-gl` and import it as follows
// import 'echarts-gl'

// register component to use
Vue.component('v-chart', ECharts)

Vue.component('default-layout', Default)
Vue.component('auth-layout', Auth)

Vue.component('v-select', vSelect)

Vue.use(Toasted)

const mediaQueries = new MediaQueries()

Vue.use(mediaQueries)

Vue.use(UUID)

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueTimers)

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

moment.locale('en', en)

Vue.component('timeline', Timeline)
let app;
fetch(process.env.BASE_URL + 'config.json')
  .then((response) => response.json())
  .then((appConfig) => {

    axios.defaults.baseURL = appConfig.apiBaseUrl;

    window.config = appConfig;
  
    Vue.prototype.$config = appConfig;

    config.contentTypes.forEach((contentType) => {
      // Register dynamically generated store modules.
      store.registerModule(
        contentType.name,
        makeCrudModule({
          service: makeService(appConfig.apiBaseUrl, contentType.endpoints),
          idKey: contentType.idKey,
        })
      )
    
      // Register dynamically generated routes.
      router.addRoutes(
        makeCrudRoutes({
          components: {
            EditContainer,
            GridContainer,
          },
          contentType,
        })
      )
    })
    
    app = new Vue({
      router,
      store,
      mediaQueries: mediaQueries,
      render: (h) => h(App),
    }).$mount('#app');
  });



// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
